import { render, staticRenderFns } from "./hourDetails.vue?vue&type=template&id=d80b8322&scoped=true&"
import script from "./hourDetails.vue?vue&type=script&lang=js&"
export * from "./hourDetails.vue?vue&type=script&lang=js&"
import style0 from "./hourDetails.vue?vue&type=style&index=0&id=d80b8322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80b8322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d80b8322')) {
      api.createRecord('d80b8322', component.options)
    } else {
      api.reload('d80b8322', component.options)
    }
    module.hot.accept("./hourDetails.vue?vue&type=template&id=d80b8322&scoped=true&", function () {
      api.rerender('d80b8322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/channelCom/hourDetails.vue"
export default component.exports